const BOYWishlist = {
  key: 'boy_wishlist_v1',
  get() {
    try { return JSON.parse(localStorage.getItem(this.key) || '[]'); } catch { return []; }
  },
  save(items) { localStorage.setItem(this.key, JSON.stringify(items)); },
  has(id) { return this.get().some(p => String(p.id) === String(id)); },
  toggle(product) {
    const items = this.get();
    const idx = items.findIndex(p => String(p.id) === String(product.id));
    if (idx > -1) { items.splice(idx, 1); this.save(items); return false; }
    else { items.push(product); this.save(items); return true; }
  },
  remove(id) { this.save(this.get().filter(p => String(p.id) !== String(id))); },
  count() { return this.get().length; }
};

function wishlistSetBtn(btn, active) {
  btn.classList.toggle('wishlist-btn--active', active);
  btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  btn.setAttribute('aria-label', active ? 'Retirer des favoris' : 'Ajouter aux favoris');
}

function wishlistInitButtons(root) {
  (root || document).querySelectorAll('[data-wishlist-id]').forEach(btn => {
    wishlistSetBtn(btn, BOYWishlist.has(btn.dataset.wishlistId));
  });
}

/* Délégation d'événements — fonctionne pour les éléments insérés dynamiquement */
document.addEventListener('click', function(e) {
  const btn = e.target.closest('[data-wishlist-id]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  const product = {
    id: btn.dataset.wishlistId,
    title: btn.dataset.wishlistTitle,
    url: btn.dataset.wishlistUrl,
    image: btn.dataset.wishlistImage,
    price: btn.dataset.wishlistPrice,
    vendor: btn.dataset.wishlistVendor || ''
  };
  const active = BOYWishlist.toggle(product);
  document.querySelectorAll(`[data-wishlist-id="${product.id}"]`).forEach(b => wishlistSetBtn(b, active));
});

/* Observer pour initialiser l'état des boutons insérés après le chargement initial */
new MutationObserver(function(mutations) {
  mutations.forEach(function(m) {
    m.addedNodes.forEach(function(node) {
      if (node.nodeType !== 1) return;
      const btns = node.querySelectorAll ? node.querySelectorAll('[data-wishlist-id]') : [];
      btns.forEach(btn => wishlistSetBtn(btn, BOYWishlist.has(btn.dataset.wishlistId)));
      if (node.matches && node.matches('[data-wishlist-id]')) {
        wishlistSetBtn(node, BOYWishlist.has(node.dataset.wishlistId));
      }
    });
  });
}).observe(document.body, { childList: true, subtree: true });

document.addEventListener('DOMContentLoaded', function () {
  wishlistInitButtons();
  wishlistRenderAccount();
});

function wishlistRenderAccount() {
  const container = document.getElementById('wishlist-account-grid');
  if (!container) return;
  const items = BOYWishlist.get();
  const emptyEl = document.getElementById('wishlist-account-empty');
  const countEl = document.getElementById('wishlist-account-count');
  if (countEl) countEl.textContent = items.length;
  if (items.length === 0) {
    container.innerHTML = '';
    if (emptyEl) emptyEl.style.display = '';
    return;
  }
  if (emptyEl) emptyEl.style.display = 'none';
  container.innerHTML = items.map(item => `
    <div class="wishlist-card" data-wl-id="${item.id}">
      <a href="${item.url}" class="wishlist-card__img-wrap">
        ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : `<div class="wishlist-card__no-img"></div>`}
      </a>
      <div class="wishlist-card__body">
        ${item.vendor ? `<p class="wishlist-card__vendor">${item.vendor}</p>` : ''}
        <a href="${item.url}" class="wishlist-card__title">${item.title}</a>
        <p class="wishlist-card__price">${item.price}</p>
        <div class="wishlist-card__actions">
          <a href="${item.url}" class="wishlist-card__cta">Voir le produit</a>
          <button class="wishlist-card__remove" data-wl-remove="${item.id}" aria-label="Retirer">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>
          </button>
        </div>
      </div>
    </div>
  `).join('');
  container.querySelectorAll('[data-wl-remove]').forEach(btn => {
    btn.addEventListener('click', function () {
      const id = this.dataset.wlRemove;
      BOYWishlist.remove(id);
      const el = container.querySelector(`[data-wl-id="${id}"]`);
      if (el) el.remove();
      if (countEl) countEl.textContent = BOYWishlist.count();
      if (BOYWishlist.count() === 0 && emptyEl) emptyEl.style.display = 'block';
    });
  });
}
